<template>
  <!--
    TODO: the logic to show/hide content is nuts, and needs to be done one by one
          the main thing is that the content is generated on some crazy things in
          the current/old JS, so we need to try and figure that out. This component
          should be populated based on what is passed in and should not do any real
          business logic to figure out what to display. Trying to keep all the logic
          in on location. This will help with future updates and changes.
  -->
  <div>
    <p v-if="session.credits === 0">
      CE credits are not available for this course.
    </p>
    <div v-else>
      <div v-if="ceInfo.certificateText && !['OT/OTA'].includes(ceInfo.profession)">
        <div v-if="ceInfo.certificateText.toUpperCase().includes('NOTICE')">
          {{ ceInfo.certificateText }}
          <p class="text-xs">
            Reference # {{ ceInfo.ceaId }}, Exp: {{ ceInfo.expirationDate }}
          </p>
        </div>
        <div v-else>
          <p>{{ ceInfo.certificateText }}</p>
          <p class="text-xs">
            Reference # {{ ceInfo.ceaId }}, Exp: {{ ceInfo.expirationDate }}
          </p>
          <template v-if=" ceInfo.profession === 'SLP'">
            <p>
              <strong>Please Note:</strong> If you would like to obtain CEUs from ASHA through Summit for completing this course, it is necessary for you to submit a brief participant form immediately upon completion of your course. Once you have met satisfactory completion requirements of the course, you will have access to the form via a <strong>“Report to ASHA”</strong> button <u>in your account for 10 days from the date of completion</u> (next to the “Certificate Download” button).
            </p>
            <p class="text-xs">
              Reference # {{ ceInfo.ceaId }}, Exp: {{ ceInfo.expirationDate }}
            </p>
          </template>
        </div>
      </div>
      <div v-if="ceInfo.certificateText === undefined || ceInfo.certificateText === ''">
        <p>Search your profession and state above to see CE for your selected course.</p>
      </div>
      <!-- This is a PT specific note that only applies to PTs and not PTAs -->
      <p v-if="session.showPtOnly">
        <strong>Content Disclosure:</strong>
        This course contains advanced content which may not be relevant to PTA scope of practice in all states. Please see your State Physical Therapy Practice Act to verify this course is acceptable for continuing education.
      </p>
      <!-- Used for Pending AOTA CE/Grandfathered AOTA courses (old way) -->
      <!-- aotaImprimatur is true so this image/text is formatted, don't want it formatted for false -->
      <template v-if="ceInfo.profession === 'OT/OTA'">
        <img
          v-if="ceInfo.ceap === 'AOTA'"
          :id="ceInfo.aotaImprimatur ? 'aota-true-img' : 'aota-false-img'"
          src="//summitproedu.imgix.net/aota.png"
          width="40%"
          :class="ceInfo.aotaImprimatur ? 'object-center' : ''"
          alt="Approved provider of continuing education by the American Occupational Therapy Association, Inc"
        />
        <p
          :id="ceInfo.aotaImprimatur ? 'aota-true-text' : 'not-aota-imprimatur'"
          :class="ceInfo.aotaImprimatur ? 'text-center' : ''"
          class="text-sm"
        >
          {{ ceInfo.certificateText }}
        </p>
        <br />
        <p class="text-xs">
          Reference # {{ ceInfo.ceaId }}, Exp: {{ ceInfo.expirationDate }}
        </p>
      </template>
      <!-- Show ASHA  -->
      <template v-if="session.hasAsha && ceInfo.profession === 'SLP'">
        <p>
          <strong>ASHA CE Information</strong>
        </p>
        <div class="flex justify-left items-center">
          <div>
            <img
              class="w-96 margin-0"
              src="https://summitproedu.imgix.net/new-asha-brand-block.png"
              alt="ASHA Continuing Education"
            />
          </div>
          <div class="ml-4">
            <p class="font-bold">
              Summit Professional Education
            </p>
            <p>
              {{ session.educationLevel }} Level
            </p>
            <p>
              {{ session.credits / 10 }} ASHA CEUs
            </p>
          </div>
        </div>
        <p>
          ASHA CE Provider approval and use of the Brand Block does not imply endorsement of course content, specific products or clinical procedures.
        </p>
        <a
          class="underline decoration-sky-600 hover:decoration-primary-100"
          href="https://support.summit-education.com/hc/en-us/articles/213879983-Does-Summit-report-to-CE-broker-ASHA-"
          target="_blank"
        >
          Does Summit report to ASHA?
        </a>
        <br />
        <p class="pt-2">
          <strong>IMPORTANT:</strong> Please be sure the name and address listed on your Summit account matches what is associated with your ASHA Member record to ensure proper allocation of CEUs.
        </p>
      </template>
      <p />
      <p v-if="courseId === 'PSPIJR.1'">
        <strong>Content Disclosure:</strong> This course contains advanced content which may not be relevant to PTA scope of practice in all states. Please see your State Physical Therapy Practice Act to verify this course is acceptable for continuing education.
      </p>
      <p v-if="courseId === 'PCSPJR.1.3CREDIT'">
        <strong>Content Disclosure:</strong> This course contains content which may not be relevant to PTA scope of practice in all states. Please see your State Physical Therapy Practice Act to verify this course is acceptable for continuing education.
      </p>
      <p />
      <p>
        <strong>Content Level: {{ session.educationLevel }}</strong>
      </p>
      <p v-if="session.productType === 'LIVE'">
        <strong>SATISFACTORY COMPLETION:</strong>
        Participants must register, pay tuition fee, sign in with a mobile device via scanning electronic QR code at workshop location, attend the entire workshop, complete an electronic evaluation,
        as well as any other required state-specific supplements (if applicable) and sign out with a mobile device via scanning electronic QR code in order to receive a certificate of completion.
        Participants not fulfilling these requirements will not receive a certificate. Failure to sign in or out and complete a course evaluation will result in forfeiture of credit for the entire
        workshop. No exceptions will be made. Partial credit is not available.
      </p>
      <div v-if="session.productType === 'WEBINAR' || session.productType === 'LIVESTREAM'">
        <p>
          <strong>SATISFACTORY COMPLETION REQUIREMENTS:</strong>
          Participants must sign in by logging into their Summit accounts and clicking the "Launch Webinar" button for the relevant webinar, attend the entire workshop, complete the evaluation, and
          pass a post-test with a score of 75% (80% for ethics/jurisprudence) or higher to receive a certificate of completion.
        </p>
        <p>
          Please note that the post-test is only available for 48 hours following the webinar. Participants not fulfilling these requirements will not receive a certificate. Failure to sign in to the
          webinar or pass the post-test will result in forfeiture of credit for the entire course. No exceptions will be made. Partial credit is not available.
        </p>
        <p>
          Attendees not joined 15 minutes after the start time (10 minutes for a 1 hour webinar) will have their registration cancelled. Please contact Summit Customer Service for options in this
          event.
        </p>
      </div>
      <p v-if="session.productType === 'VIDEO' || session.productType === 'TEXT' ">
        <strong>SATISFACTORY COMPLETION:</strong>
        Participants must view the entire course, complete an evaluation, and pass a post-test with a score of 75% (80% for ethics/jurisprudence) or higher to receive a certificate of completion.
        Participants not fulfilling these requirements will not receive a certificate. Failure to meet these requirements will result in forfeiture of credit
        for the entire course. No exceptions will be made. Partial credit is not available.
      </p>
      <p v-if="session.productType === 'PODCAST'">
        <strong>SATISFACTORY COMPLETION:</strong>
        Participants must view/attend the entire course, complete an evaluation, and pass a post-test with a score of 75% (80% for ethics/jurisprudence) or higher to receive a certificate of completion. Participants not fulfilling these requirements will not receive a certificate. Failure to meet these requirements will result in forfeiture of credit for the entire course. No exceptions will be made. Partial credit is not available.
      </p>
      <p>
        <strong>SCOPE OF PRACTICE:</strong>
        Workshop content is not intended for use by participants outside of the regulatory scope of practice of their license(s). You are responsible for knowing what lies within and without your
        professional scope of practice.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CeInfo',
  props: {
    ceInfo: {
      type: Object,
      required: true,
    },
    session: {
      type: Object,
      required: true,
    },
    courseId: {
      type: String,
      default: '',
    },
  },
};
</script>

<style>
#aota-true-text {
  margin: 0 250px;
  padding-top: 25px;
  line-height: 2;
}

@media only screen and (width <= 880px) {
  #aota-true-text {
    margin: 0 50px;
    padding-top: 25px;
    line-height: 2;
  }
}

#aota-true-img {
  margin: 0 auto;
  padding-top: 25px;
  line-height: 2;
}
</style>
